import { Component, computed, input, output } from '@angular/core';
import { Filters, MainFilterOption } from '../../models';
import { ButtonComponent, IconButtonComponent, IconComponent, SpinnerComponent } from '../../../base';
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelDescription,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion';
import { MatCheckbox } from '@angular/material/checkbox';
import { TranslateModule } from '@ngx-translate/core';
import { MatListOption, MatSelectionList } from '@angular/material/list';
import { AsyncPipe, NgClass } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDivider } from '@angular/material/divider';
import { MatFormField, MatPrefix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { BaseFilterComponent } from '../../directives';

@Component({
  selector: 'spx-filter-accordion',
  templateUrl: './filter-accordion.component.html',
  styleUrls: ['./filter-accordion.component.scss'],
  standalone: true,
  imports: [
    TranslateModule,
    MatCheckbox,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatAccordion,
    MatSelectionList,
    MatExpansionPanelDescription,
    MatListOption,
    FormsModule,
    MatDivider,
    MatFormField,
    MatInput,
    MatPrefix,
    ReactiveFormsModule,
    SpinnerComponent,
    AsyncPipe,
    NgClass,
    ButtonComponent,
    IconComponent,
    IconButtonComponent,
  ],
})
export class FilterAccordionComponent extends BaseFilterComponent {
  protected filters = input.required<Filters>();
  protected filterOptions = input.required<MainFilterOption[]>();
  protected filterLabels = input<Record<string, string>>({});
  protected showClearAll = input(false);

  protected closeAccordion = output<void>();
  protected clearFilters = output<void>();
  protected toggleFilter = output<{ key: string; value: string | boolean }>();
  protected apply = output<void>();

  protected filterLength = computed(() =>
    Object.values(this.filters()).reduce((sum, entry) => {
      const value = Array.isArray(entry) ? entry.length : 1;
      return sum + value;
    }, 0),
  );

  constructor() {
    super();
  }

  protected emitToggleFilter(key: string, value: string | boolean): void {
    this.toggleFilter.emit({ key, value });
  }

  protected applyFilters(): void {
    this.apply.emit();
  }

  protected switchPanelState(option: MainFilterOption): void {
    this.loadInitialData(option);
  }
}
